import { render, staticRenderFns } from "./SkillCardHome.vue?vue&type=template&id=863c7158&scoped=true&"
import script from "./SkillCardHome.vue?vue&type=script&lang=js&"
export * from "./SkillCardHome.vue?vue&type=script&lang=js&"
import style0 from "./SkillCardHome.vue?vue&type=style&index=0&id=863c7158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863c7158",
  null
  
)

export default component.exports